<template>
  <div class="hc-compact-page hc-prescriptions-page">

    <!-- Header Card -->
        <PageHeader icon="fas fa-prescription-bottle-alt">
      <template #title>
        Daftar Resep Obat {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola dan terbitkan resep obat pasien
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="manipulateBtn == true"
                @click="$router.push('/prescriptions/add')">
                <i class="fas fa-plus"></i>
                <span>Buat Resep Baru</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table
              :items="items"
              :fields="fields"
              :hasPatient="false"
              :perPage="perPage"
              :currentPage="currentPage"
              :lastCurrentPage="lastCurrentPage"
              :totalRows="totalRows"
              :selectPrescription="false"
              @filterByPeriode="generalFilter"
              @filterByDoctor="generalFilter"
              @filterByPatient="generalFilter"
              @btnDeleteOnClick="btnDeleteOnClick"
              @visit-completed="pagination"
              @pageOnClick="pageOnClick"
            />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Table from '@/component/prescriptions/Table.vue'
import module from "@/core/modules/CrudModule.js"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import { getUser } from '@/core/services/jwt.service.js'

export default {

  components: {
    Card,
    Table
  },

  data() {
    return {
      // Filter
      filter: {
        doctor_id: "",
        patient_name: "",
        start_date: "",
        end_date: "",
        // start_date: window.medhopToday(),
        // end_date: window.medhopToday(),
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      lastCurrentPage: 1,
      totalRows: 0,
      // Table Fields
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "display_date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "doctor_name",
          label: "Dokter",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Pasien",
          sortable: true,
        },
        {
          key: "redeem_type",
          label: "Jenis Penebusan",
          sortable: true,
        },
        {
          key: "redeem_status_display",
          label: "Status Obat",
          sortable: true,
        },
        {
          key: "visit_status_display",
          label: "Status Kunjungan",
          sortable: true,
        },
        // {
        //   key: "display_medicine",
        //   label: "Obat",
        //   sortable: true,
        // },
        { key: "actions", label: "Aksi", thClass: "th-action-prescription" },
      ],
      // Table Items
      items: [],
      // access management
      manipulateBtn: false,
      // current user
      currentUser: getUser(),
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.lastCurrentPage = page
      this.pagination()
    },

    async pagination() {
      let route
      if (this.currentUser.user_type_id == 1) {
        route = `prescriptions/get-by-doctor/${this.currentUser.id}`
      } else {
        route = 'prescriptions'
      }
      let filterParams = `&doctor_id=${this.filter.doctor_id}&patient_name=${this.filter.patient_name}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`
      let response = await module.paginate(route, `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    generalFilter(sended) {
      this.filter.doctor_id = sended.doctor_id
      this.filter.start_date = sended.start_date
      this.filter.end_date = sended.end_date
      this.filter.patient_name = sended.patient_name

      if (this.filter.patient_name != "" || this.filter.doctor_id != '' || this.filter.start_date != '' || this.filter.end_date != '') {
        this.currentPage = 1;
      } else {
        this.currentPage = this.lastCurrentPage;
      }
      this.pagination()
    },

    async btnDeleteOnClick(id) {
      // Delete Data
      let result = await module.delete("prescriptions/" + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)
      let a
      for (a = 0; a < access_right.length; a++) {
        
        if (access_right[a] == "8002") {
          this.manipulateBtn = true
        }
      }
    },
    
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Daftar Resep Obat" }])
    // Get Table Data
    this.pagination()
    this.setActiveMenu()
  },

}
</script>
